var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSendnotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ADADD0",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 17.875H3c-1.105 0-2-.924-2-2.063 0-1.139.895-2.062 2-2.062a.677.677 0 0 0 .667-.688V8.937c0-2.087.82-3.978 2.148-5.347v.001a.65.65 0 0 1 .476-.208c.369 0 .667.308.667.688a.693.693 0 0 1-.201.49v.001A6.263 6.263 0 0 0 5 8.937v4.47c0 .949-.747 1.718-1.667 1.718H3a.677.677 0 0 0-.667.687c0 .38.298.688.667.688h16a.678.678 0 0 0 .667-.688.678.678 0 0 0-.668-.687h-.333c-.92 0-1.666-.77-1.666-1.719V8.937c0-3.14-2.27-5.726-5.208-6.127.004-.005.004-.009-.001-.01-.822-.106-1.458-.828-1.458-1.705V.687c0-.38.299-.687.667-.687.368 0 .666.307.666.687v.258c0 .256.18.467.417.509a.29.29 0 0 0-.103 0c3.585.495 6.353 3.651 6.353 7.483v4.125c0 .38.299.688.666.688 1.105 0 2.001.923 2.001 2.062 0 1.14-.895 2.063-2 2.063z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.333 19.937c0 .38.299.688.667.688a.677.677 0 0 0 .666-.688c0-.379.3-.687.667-.687.369 0 .667.308.667.687 0 1.14-.896 2.063-2 2.063-1.105 0-2-.923-2-2.063 0-.379.298-.687.667-.687.368 0 .666.308.666.687z",
    opacity: 0.602
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSendnotifications);
export default __webpack_public_path__ + "static/media/icon-sendnotifications.c398402639b40e1c9f6e0bb99bbc5484.svg";
export { ForwardRef as ReactComponent };